/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";

import { Typography } from "@material-ui/core";

import FlexInput from './Components/FlexInput';
import FlexSelect from './Components/FlexSelect';
import FlexMultiSelect from './Components/FlexMultiSelect';
import FlexGroup from './Components/FlexGroup';
import FlexSlider from './Components/FlexSlider';
import FlexTextList from './Components/FlexTextList';
import FlexSwitch from "./Components/FlexSwitch";
import FlexDatePicker from "./Components/FlexDatePicker";
import FlexScheduler from "./Components/FlexScheduler";
import EventPicker from './Components/EventPicker/EventPicker'
import FlexBotPicker from './Components/FlexBotPicker'
import FlexTZPicker from './Components/FlexTZPicker'
import FlexDisplayCard from './Components/FlexDisplayCard'
import FlexDisplayLongText from './Components/FlexDisplayLongText'
import AttachmentContainer from "../../Queue/components/AttachmentContainer";

const Elements = {
    text : FlexInput,
    number : FlexInput,
    email : FlexInput,
    password : FlexInput,
    url : FlexInput,
    select : FlexSelect,
    multi_select : FlexMultiSelect,
    group : FlexGroup,
    slider : FlexSlider,
    text_list: FlexTextList,
    switch: FlexSwitch,
    date: FlexDatePicker,
    event : EventPicker,
    bot : FlexBotPicker,
    timezone : FlexTZPicker,
    display_card : FlexDisplayCard,
    display_long_text : FlexDisplayLongText
}

let acceptsAttachment = (instance) => {
  if (instance.component_params) {
    let attachment_param = instance.component_params.find(param => param.name === 'accept_attachment')
    if (attachment_param) {
      return attachment_param.value.boolean
    } else {
      return false
    }
  } else {
    return false
  }
}

let render_element =  (instance, additional_props) => {
  if (typeof Elements[instance.component] !== "undefined") {
    console.log('Show Attachments : ', additional_props.show_attachment)
    return (
      <div style = {{padding : '3px'}}>
          {
            React.createElement(Elements[instance.component], {
              key: instance.id,
              instance: instance,
              ...additional_props,
            })
          }
        {additional_props.show_attachment && 
          <div style = {{marginTop : '5px'}}>
            <AttachmentContainer
              accepts_attachments = {acceptsAttachment(instance)}
              key = {instance.id}
              attachments = {Array.isArray(instance.attachments) ? instance.attachments : []}
              drl_url = {additional_props.drl_url}
              ic_name = {additional_props.ic_name}
              additional_attachments = {[]}
              add_attachments = {(attachment) => additional_props.add_attachments(instance.name, attachment)}
              on_open = {additional_props.on_open}
            />
          </div>
        }
      </div>
    );
  } else {
    return (
      <Typography>
        The element <em>{instance.component}</em> is not supported
      </Typography>
    );
  }
};

export default render_element